import React from 'react';
import { Box, Container, Flex, Group, Skeleton, Title } from '@mantine/core';
import { NavigationWrapper } from '../../components/navigation/NavigationWrapper';
import { useApp } from '../../context/AppContext';

export const EditProfileSkeleton: React.FC = () => {
  const { isTabletAndBelow, scrollAreaHeight } = useApp();

  const inputSkeleton = (height = 56) => (
    <Box mb="sm">
      <Skeleton height={14} width={100} mb={6} radius="sm" />
      <Skeleton height={height} radius="sm" />
    </Box>
  );

  const boxSectionSkeleton = (label: string) => (
    <Box mb="sm">
      <Skeleton height={14} width={80} mb={6} radius="sm" />
      <Box
        style={{
          border: '1px solid var(--mantine-color-gray-3)',
          borderRadius: 'var(--mantine-radius-sm)',
          padding: 'var(--mantine-spacing-md)',
        }}
      >
        <Group gap="xs">
          <Skeleton height={22} width={70} radius="xl" />
          <Skeleton height={22} width={90} radius="xl" />
          <Skeleton height={22} width={60} radius="xl" />
        </Group>
      </Box>
    </Box>
  );

  return (
    <NavigationWrapper>
      <Container
        size={isTabletAndBelow ? '100%' : 1400}
        py={{ base: 0, sm: 'lg', md: 'xl' }}
        px={{ base: 0, sm: 'lg' }}
        style={{ width: '100%' }}
      >
        <Box
          style={{
            backgroundColor: '#fff',
            padding: isTabletAndBelow
              ? 'var(--mantine-spacing-md)'
              : 'var(--mantine-spacing-lg)',
            boxShadow: '0 1px 8px rgba(0, 0, 0, 0.1)',
            minHeight: isTabletAndBelow ? scrollAreaHeight : 'auto',
            width: '100%',
            maxWidth: isTabletAndBelow ? '100%' : 1200,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Title order={3} fw="normal" mb="lg">
            Edit Profile
          </Title>

          {/* Avatar */}
          <Flex justify="center" mb="lg">
            <Skeleton height={150} width={150} circle />
          </Flex>

          {/* Basic fields */}
          {inputSkeleton()}
          {inputSkeleton()}
          {inputSkeleton()}
          {inputSkeleton()}

          {/* Header Bio textarea */}
          {inputSkeleton(120)}

          {/* City, Rate, Username */}
          {inputSkeleton()}
          {inputSkeleton()}
          {inputSkeleton()}

          {/* Social media inputs */}
          {inputSkeleton()}
          {inputSkeleton()}
          {inputSkeleton()}
          {inputSkeleton()}
          {inputSkeleton()}
          {inputSkeleton()}

          {/* About textarea */}
          {inputSkeleton(120)}

          {/* Categories, Search Terms, Languages */}
          {boxSectionSkeleton('Categories')}
          {boxSectionSkeleton('Search Terms')}
          {boxSectionSkeleton('Languages')}

          {/* Professional toggle */}
          <Group mb="sm" align="center">
            <Skeleton height={24} width={200} radius="sm" />
          </Group>

          {/* Submit button */}
          <Skeleton height={42} radius="md" />
        </Box>
      </Container>
    </NavigationWrapper>
  );
};
